<div class="modal-header">
    <h6>{{'interviews.Review and Send Feedback' | translate}}</h6>
    <button type="button"
            class="close"
            aria-label="Close"
            (click)="activeModal.dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <h3 class="space-bottom-xs">{{interview.video_interview.title}} — {{interview.student._label}}</h3>
    <p class="space-bottom-xl text-gray">{{'interviews.Attempt Recorded' | translate}} {{formattedInterviewDate}}</p>
    <ul *ngIf="hasFeedback else noFeedbackInterview">
        <li *ngFor="let question of interview.questions; let i = index;" class="space-bottom-lg" [ngClass]="{'border-bottom' : i !== interview.questions.length - 1}">
            <p class="feedback-question" class="inline-block text-bold">
                {{i + 1}}. {{question.question_text}}
            </p>
            <ng-container *ngIf="(reviewerFeedback[i].rating !== '0' && reviewerFeedback[i].rating !== null && reviewerFeedback[i].rating !== '') ||
                                reviewerFeedback[i].review else noFeedbackQuestion">
                    <app-rating *ngIf="(reviewerFeedback[i].rating !== '0' && reviewerFeedback[i].rating !== '' && reviewerFeedback[i].rating !== null)" class="read-only clearfix" [rating]="reviewerFeedback[i].rating" [itemId]='3'></app-rating>
               <p>
                   <q *ngIf="reviewerFeedback[i].review" class="space-top-xs space-bottom-lg" [innerHTML]="reviewerFeedback[i].review | keepHtml"></q>
               </p>
            </ng-container>
            <ng-template #noFeedbackQuestion><div class="space-top-xs space-bottom-lg">{{'interviews.No Feedback' | translate}}</div></ng-template>
        </li>
    </ul>
    <ng-template #noFeedbackInterview><h4>{{'interviews.No Feedback For Interview' | translate}}</h4></ng-template>
</div>
<div class="modal-footer">
    <button class="btn btn_default"
            (click)="activeModal.close(false)">{{'interviews.Edit Feedback' | translate}}
    </button>
    <button class="btn btn_primary no-margin"
            [disabled]="!hasFeedback"
            (click)="activeModal.close(true)">{{'interviews.Send' | translate}}
    </button>
</div>
